import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromGroupUsers from './reducers/group-users.reducer';
import { EffectsModule } from '@ngrx/effects';
import { LoadGroupUsersEffects } from './effects/load-group-users.effects';
import { UserSelectorContainerComponent } from './containers/user-selector-container/user-selector-container.component';
import { UserSelectorItemComponent } from './components/user-selector-item/user-selector-item.component';
import { SharedModule } from '@shared/shared.module';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
@NgModule({
  declarations: [UserSelectorContainerComponent, UserSelectorItemComponent],
  imports: [
    CommonModule,
    IonicModule,
    SharedModule,
    ReactiveFormsModule,
    StoreModule.forFeature(fromGroupUsers.featureKey, fromGroupUsers.reducer),
    EffectsModule.forFeature([LoadGroupUsersEffects]),
  ],
  exports: [UserSelectorContainerComponent, UserSelectorItemComponent],
})
export class UsersSharedModule {}
